import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CqFileDestination } from 'src/app/beans/components/cq-file/cq-file-destination.bean';
import { DeviceActivation } from 'src/app/beans/device/device.activation.bean';
import { DeviceDetail } from 'src/app/beans/device/device.detail.bean';
import { CustomValidator } from 'src/app/beans/errors/custom-validator.bean';
import { User } from 'src/app/beans/login/user/user.bean';
import { Site } from 'src/app/beans/site/site.bean';
import { DeviceCloneDialog } from 'src/app/dialogs/device/device.clone.dialog';
import { AuthLevel } from 'src/app/enums/auth/auth.enum';
import { DialogsReturnCode } from 'src/app/enums/dialogs/returnCode.enum';
import { RoutingPages } from 'src/app/enums/routing/routing-pages.enum';
import { isSessionCode     } from 'src/app/enums/session/session-code.enum';
import { HandlerManager    } from 'src/app/managers/handler/handler.manager';
import { LoadingManager    } from 'src/app/managers/loading/loading.manager';
import { SessionManager    } from 'src/app/managers/session/session.manager';
import { extensionMatch } from 'src/app/validators/extension.validator';
import { genericValidator } from 'src/app/validators/generic.validator';
var FileSaver = require('file-saver');

@Component
({
  selector: 'device-data-container',
  templateUrl: './device.data.container.html',
  styleUrls: ['./device.data.container.scss']
})

export class DeviceDataContainer implements OnInit 
{
  deviceDetail: DeviceDetail = new DeviceDetail()
  @Input('deviceDetail') set _deviceDetail(deviceDetail: DeviceDetail)
  {        
    this.action = ""
    if(deviceDetail)
    {
      this.deviceDetail = deviceDetail
    }else{
      this.deviceDetail = null
    }
  }

  @Input('site') site: Site
  
  @Output('refresh') refresh: EventEmitter<void> = new EventEmitter()

  action: string 
  advanced: number = 0

  savedDeviceDetail: DeviceDetail = new DeviceDetail()

  public types: any[] = 
  [
    { 
      name: "device.name.codino",
      id  : 10
    },
    { 
      name: "device.name.counter",
      id  : 20
    },
    { 
      name: "device.name.summary",
      id  : 30
    },
  ]

  //--------------------------------------------------------------------------------

  logo_validators: CustomValidator[] = [
    {
      isValid     :   Validators.required ,
      validation  :  {
        validatorName   : "required",
        text            : "media.validators.logo.required"
      }
    },
    {
      isValid     :   extensionMatch(['png', 'jpeg', 'jpg']) ,
      validation  :  {
        validatorName   : "png",
        text            : "media.validators.default.only_img"
      }
    }
  ]

  ticket_validators: CustomValidator[] = [
    {
      isValid     :   extensionMatch(['png', 'jpeg', 'jpg']) ,
      validation  :  {
        validatorName   : "png",
        text            : "media.validators.default.only_img"
      }
    }
  ]

  logo    = new FormControl('', genericValidator( this.logo_validators ))
  ticket  = new FormControl('', genericValidator( this.ticket_validators ))



  getDest( type: string, code: string ): CqFileDestination
  {
    if(   this.action != "update" ) return null
    return {
      level       : "DE",
      levelid     : this.deviceDetail.id ,
      type        : type,
      code        : code
    }
  }
  //--------------------------------------------------------------------------------

  constructor
  (
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
    private _dialog : MatDialog     ,
    private _router : Router
  ) {}

  //--------------------------------------------------------------------------------
  
  ngOnInit(): void 
  {
    //this.deviceDetail.enabled = 1
  }

  init()
  {}

  //--------------------------------------------------------------------------------
  
  async save()
  {
    this.defaultOperation()

    if  (this.action && this.action == "create") await this.createDevice() 
    else                                         await this.update()

    this.action = "update"

    this.refresh.emit()
  }

  clone()
  {
    this.action = "clone"

    this.openDialog()

    this.action = "update"
  }

  create()
  {

    if( !this.deviceDetail )
      this.initDeviceCreate()
    else
      this.saveDeviceData()


    let savedType: number = 10
    if(this.deviceDetail && this.deviceDetail.type) savedType = this.deviceDetail.type
    if(this.deviceDetail) this.setFildsToNull(this.deviceDetail)
    
    this.deviceDetail.type = savedType
    this.action = "create"
  }

  cancel()
  {
    console.log( this.savedDeviceDetail?.id );
        
    if(!this.savedDeviceDetail?.id){
      this.action = ""
      this.deviceDetail = null
      return 
    }

    this.deviceDetail = this.savedDeviceDetail
    this.action = "update"
  }
  
  async activation()
  {
    let deviceActivation = await this.deviceActivation() as DeviceActivation

    if(deviceActivation)
    {      
      let space = "\r\n"
      let file = "activation=" + deviceActivation.activation + space
      let fileName = "config.properties"

      if(deviceActivation.type == 20)
      {
        fileName = "Jnext.properties"
        if(deviceActivation.uniqueDeviceId) file += "uniqueDeviceId=" + deviceActivation.uniqueDeviceId + space
        file += "baseServer=" + deviceActivation.baseServer
      }

      try 
      {
        var blob = new Blob([file])
        console.log(blob)
        FileSaver.saveAs(blob, fileName)
      }
      catch(error)
      {
        console.log(error)
      }
    }
  }

  assignOperator()
  {
    this._router.navigate( [ RoutingPages.ASSIGN_OPERATOR ] )
  }

  //--------------------------------------------------------------------------------
  
  defaultOperation()
  {
    let type = this.deviceDetail.type

    if(type == 30) this.deviceDetail.beep   = this.deviceDetail.beep   ? 1 : 0
    if(type == 30) this.deviceDetail.speech = this.deviceDetail.speech ? 1 : 0
    
    this.deviceDetail.enabled = this.deviceDetail.enabled ? 1 : 0
  }

  saveDeviceData()
  {
    this.savedDeviceDetail = new DeviceDetail()
    this.savedDeviceDetail.id                = this.deviceDetail.id
    this.savedDeviceDetail.type              = this.deviceDetail.type
    this.savedDeviceDetail.deviceName        = this.deviceDetail.deviceName
    this.savedDeviceDetail.counterName       = this.deviceDetail.counterName
    this.savedDeviceDetail.configurationJson = this.deviceDetail.configurationJson
    this.savedDeviceDetail.beep              = this.deviceDetail.beep
    this.savedDeviceDetail.speech            = this.deviceDetail.speech
    this.savedDeviceDetail.speechMessage     = this.deviceDetail.speechMessage
    this.savedDeviceDetail.speechCounter     = this.deviceDetail.speechCounter
    this.savedDeviceDetail.dateLicensed      = this.deviceDetail.dateLicensed
    this.savedDeviceDetail.open              = this.deviceDetail.open
    this.savedDeviceDetail.notes             = this.deviceDetail.notes
    this.savedDeviceDetail.enabled           = this.deviceDetail.enabled    
  }

  openDialog()
  {
    const dialogConfig = new MatDialogConfig()

    dialogConfig.disableClose = true
    dialogConfig.autoFocus    = true

    let dialog: any
    
    dialogConfig.data = 
    {
        type: this.deviceDetail.type
      , title: "dialog.device.title"
      , body: "dialog.device.body"
      , confirm_text: "dialog.device.confirm_text"
      , cancel_text : "dialog.device.cancel_text"
      , deviceName: "dialog.device.deviceName"
      , counterName: "dialog.device.counterName"
    }

    dialog = this._dialog.open(DeviceCloneDialog, dialogConfig);
    
    dialog.afterClosed().subscribe(async (data: any) =>
    {
      //Delete message and refresh table data
      if(data.code == DialogsReturnCode.OPERATION_ACCEPTED)
      {
        this.deviceDetail.deviceName  = data.deviceName
        this.deviceDetail.counterName = data.counterName

        this.defaultOperation()

        await this.createDevice()

        this.refresh.emit()
      }
    })
  }

  async update()
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()

    await this._handler.device().update((user as User).token, this.deviceDetail.id, this.deviceDetail)

    this._loader.stop()
  }

  async createDevice()
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()

    await this._handler.device().create((user as User).token, this.site.id, this.deviceDetail)

    this._loader.stop()
  }

  async deviceActivation()
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()

    let response = null
    response = await this._handler.device().activation((user as User).token, this.deviceDetail) as DeviceActivation

    this._loader.stop()

    if(!response || !response.object) return
    return response.object
  }
  
  //--------------------------------------------------------------------------------
  
  typeChange(el: any)
  {
    this.deviceDetail.type = el.id
  }

  getOpen()
  {
    return this.deviceDetail.open ? "device.value.on" : "device.value.off"
  }

  setFildsToNull(object: any)
  {
    for (var key in object) 
    {
      object[key] = null;
      if(key == "enabled") object[key] = 1
    }
  }

  isHubManager()
  {
    const resp = this._session.user().get()
    if(isSessionCode(resp)) return false

    const user: User = resp as User
    
    return (AuthLevel.HUB_MANAGER == user.level) ? true : false
  }

  initDeviceCreate(){
    this.action = "create"
    this.deviceDetail = {
      id         		    : 0 ,
      type              : 0 ,
      deviceName        : "",
      counterName       : "",
      configurationJson : "",
      logoId    		    : 0 ,
      ticketId          : 0 ,
      promoId           : 0 ,
      openingCalendarId : 0 ,
      beep              : 0 ,
      speech            : 0 ,
      speechMessage     : "",
      speechCounter     : "",
      dateLicensed      : "",
      open              : 0 ,
      notes   		      : "",
      enabled           : 0
    }
  }

}
